"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
const shadows = {
  outline: '0 0 0 3px rgba(91, 170, 250, 0.7)',
  // primary.400, 70% opacity
  drawer: '-8px 0 16px 0 rgba(33,33,33,.1)'
};
var _default = exports.default = (0, _merge.default)(_theme.default.shadows, shadows);